import {
  Route,
  BrowserRouter as Router,
  Routes,
  Navigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoginPage from "./pages/login/Login";
import ForgotPassword from "./pages/login/ForgotPassword";
import ChangePassword from "./pages/login/ChangePassword";
import { AuthProvider } from "./contexts/AuthContext";
import RootLayout from "./pages/Root";
import Home from "./pages/Home";
import WalletSetup from "./pages/wallet/WalletSetup";
import OAuthCallback from "./pages/wallet/OAuthCallback";
import DisputeDetailsPage from "./pages/dispute/DisputeDetailsPage";
import RequireAuth from "./route-guards/RequireAuth";
import Logout from "./pages/login/Logout";
import LoggedOut from "./pages/login/LoggedOut";

import "react-toastify/dist/ReactToastify.css";
import "./App.css";

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/login/forgot-password" element={<ForgotPassword />} />
          <Route path="/login/change-password" element={<ChangePassword />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/logged-out" element={<LoggedOut />} />
          <Route path="/" element={<RequireAuth />}>
            <Route path="/" element={<RootLayout />}>
              <Route index element={<Home />} />
              <Route
                path="disputes/:disputeId"
                element={<DisputeDetailsPage />}
              />
              <Route path="wallet/setup" element={<WalletSetup />} />
              <Route path="wallet/setup/callback" element={<OAuthCallback />} />
            </Route>
          </Route>
          {/* Catch-all route - redirect any non-existent routes to login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
        <ToastContainer />
      </AuthProvider>
    </Router>
  );
}

export default App;
